import { render, staticRenderFns } from "./JobCategoryIcon.vue?vue&type=template&id=0852a650&scoped=true"
import script from "./JobCategoryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./JobCategoryIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobCategoryIcon.vue?vue&type=style&index=0&id=0852a650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852a650",
  null
  
)

export default component.exports